import {useState, useEffect} from 'react'
import {useParams, Link} from 'react-router-dom'
import {API_ENDPOINT} from './context'

export default function Movie() {

    const {id} = useParams()
    const [movie, setMovie] = useState({})
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState({show:false,msg:''})
    //to fetch single movie
    const fetchMovie = async (url) => {
        const response = await fetch(url)
        const data = await response.json()
        if(data.Response === 'False'){
            setError({show:true,msg:data.Error})
            setLoading(false)
        }
        else{
            setMovie(data)
            setLoading(false)
        }
    }

    useEffect(() => {
     fetchMovie(`${API_ENDPOINT}&i=${id}`)
    },[id])

    if (loading){
        return <div className="loading">   
        </div>
    }
    if (error.show){
        return (
            <div className="page-error">
                <h1>{error.msg}</h1>
             <Link to="/" className="btn">
              Back to Movies
             </Link>
            </div>
        )
     
    }
    const {Poster,Title,Plot,Year,Country,Genre,Language,imdbRating,Actors,Runtime} = movie
    return (
        <section className="single-movie">
            <img src={Poster} alt={Title} />
        <div>
            <h2>{Title}</h2>
            <h4>{imdbRating} ⭐ | {Year} | {Runtime}</h4>
            <h4>{Genre}</h4>
            <h4>Cast: {Actors}</h4>
            <h4>Languages: {Language}</h4>
            <h4>{Country}</h4>
            <p>{Plot}</p>
            <Link to="/" className="btn">
                Back to Movies
            </Link>
        </div>
        </section>
    )
}
